/** sessionStorage timestamp of last auto-reload for chunk failure (debounces infinite loops). */
const CHUNK_RELOAD_TS_KEY = "pp_chunk_reload_ts";
/** Cooldown: skip auto-reload if we already reloaded within this window (broken deploy / loop guard). */
const RELOAD_COOLDOWN_MS = 4000;

function isChunkLoadFailure(reason) {
  if (!reason) return false;
  const name = reason.name || "";
  const msg = String(reason.message || reason || "");
  return (
    name === "ChunkLoadError" ||
    /loading chunk [\w.-]+ failed/i.test(msg) ||
    /ChunkLoadError/i.test(msg)
  );
}

/**
 * After a deploy, cached HTML or an old main bundle can still reference removed hashed chunks.
 * One reload usually fetches a consistent build. Debounced so a permanently missing chunk
 * does not reload forever.
 */
export function registerChunkLoadRecovery() {
  window.addEventListener("unhandledrejection", (event) => {
    if (!isChunkLoadFailure(event.reason)) return;
    const now = Date.now();
    const last = parseInt(sessionStorage.getItem(CHUNK_RELOAD_TS_KEY) || "0", 10);
    if (now - last < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_TS_KEY, String(now));
    window.location.reload();
  });
}
